import { styled } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";

const PrimaryTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    backgroundColor: theme.palette.table.primary.dark,
    color: theme.palette.table.primary.contrastText,
    fontWeight: "bold",
  },
  "&.MuiTableCell-body": {
    padding: "8px",
    textAlign: "center",
    margin: "auto",
  },
}));

export default PrimaryTableCell;
